import React from 'react';
import ClientCard from './ClientCard';
import './ClientSection.css';
import Client1 from '../../assets/imgs/clients/client1.jpg';
import Client2 from '../../assets/imgs/clients/client2.png';
import Client3 from '../../assets/imgs/clients/client11.jpg';
import Client4 from '../../assets/imgs/clients/client4.png';
import Client5 from '../../assets/imgs/clients/client5.png';
import Client6 from '../../assets/imgs/clients/client6.png';
import Client7 from '../../assets/imgs/clients/client7.png';
import Client8 from '../../assets/imgs/clients/client8.png';
import Client9 from '../../assets/imgs/clients/client9.png';
import Client10 from '../../assets/imgs/clients/client10.png';

const ClientsSection = () => {
  const clients = [
    { imageUrl: Client1, name: "React" },
    { imageUrl: Client2, name: "Samsung" },
    { imageUrl: Client3, name: "Amazon" },
    { imageUrl: Client4, name: "Apple" },
    { imageUrl: Client5, name: "Microsoft" },
    { imageUrl: Client6, name: "Google" },
    { imageUrl: Client7, name: "Tesla" },
    { imageUrl: Client8, name: "Netflix" },
    { imageUrl: Client9, name: "Adobe" },
    { imageUrl: Client10, name: "Intel" }
  ];

  return (
    <section id="clients" className="clients-section">
      <div className="clients-header">
        <h2 className="section-title">Our Valued Clients</h2>
        <p className="section-subtitle">
          Trusted by industry leaders and innovative startups worldwide
        </p>
      </div>
      
      <div className="clients-content">
        <ClientCard clients={clients} />
      </div>
    </section>
  );
};

export default ClientsSection;